import { csvToArray } from '@/helpers/StringHelpers'

// Fallback on  a stub for unit tests.
let environment = {
  config: {},
  portal: {},
  web: {},
  portalStrings: {},
  ...window.tix,
} as TixEnvironment

if (window.Cypress && window.__configPreprocessor) {
  environment = window.__configPreprocessor(environment)
}

export default environment

// Export various frequently used variables explicitly for convenient access.
export const portal = environment.portal
export const config = environment.config

// tix-api calls this a "grant type".
const method = environment.web.authentication_method
export const authenticationMethod: AuthenticationMethodName | undefined = method === 'none' ? undefined : method

export const categoriesThatMayConflict = new Set(environment.web.conflict_avoidance?.exclude_categories)

export const defaultLedgerType = environment.ledgers?.config.default_type ?? 'giftcard'

/**
 * @deprecated TODO Use .AppEnv or .AppEnvCode instead.
 * @see https://tixtrackteam.slack.com/archives/CP9C2ET5E/p1654582489303329
 * @see https://github.com/stqry/tix-web/blob/5c0d25d35c662138e4fa5b37844cbf49b1bbb60a/util/app.go#L13-L14
 */
export const environmentName = getEnvironmentName()

function getEnvironmentName() {
  const host = window.location.hostname

  const endings = 'localhost, .ngrok.io, .local.d1tix.com'
  if (csvToArray(endings).some((ending) => host.endsWith(ending))) {
    return 'local'
  } else if (host.endsWith('web.d1tix.com') || host.includes('staging')) {
    return 'd1tix'
  } else {
    // Default to production to be sure not to miss anything.
    return 'prod'
  }
}

export function sellerConfig<Key extends keyof TixEnvironment['web']>(name: Key): TixEnvironment['web'][Key] {
  const sellerOverride = environment.sellerMeta?.[name] as TixEnvironment['web'][Key]
  return sellerOverride ?? environment.web[name]
}

export function logTicketureVersion() {
  const branch = environment.config.tix_web_app_version
  if (environmentName !== 'local' && branch) {
    const common = 'display: inline-block; padding: 5px 10px;'
    const firstStyle = common + 'background: navy; color: white; border-radius: 6px 0 0 6px;'
    const lastStyle = common + 'background: black; color: lime; border-radius: 0 6px 6px 0;'
    /* eslint-disable no-console */
    console.log(`%cTicketure version %c${branch}`, firstStyle, lastStyle)
    TrackJS?.addMetadata('git branch', branch)
  }
}
